import { render, staticRenderFns } from "./ResetEmailPassword.vue?vue&type=template&id=2cf1c5ea"
import script from "./ResetEmailPassword.vue?vue&type=script&lang=js"
export * from "./ResetEmailPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports